// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  --about-type-heading: clamp(2rem, 3vw, 3rem);
  --about-type-subheading: clamp(1.5rem, 2.2vw, 2.15rem);
  --about-type-card-heading: 1.35rem;
  --about-type-body: 1.1rem;
  --about-type-body-lg: 1.2rem;
  min-height: 100vh;
  background: #ece4ed;
  color: #400C4D;
  font-family: 'Inter', system-ui, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 2.5rem 0.6rem 3rem;
}

.about-hero,
.about-block,
.about-quote,
.about-philosophy {
  width: min(1220px, 100%);
  margin: 0 auto;
}

.about-hero {
  background: #ffffff;
  border: 1px solid rgba(64, 12, 77, 0.12);
  border-radius: 16px;
  padding: 1.5rem 1.35rem;
}

.about-eyebrow {
  margin: 0 0 0.6rem;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #400C4D;
}

.about-hero h1 {
  margin: 0 0 0.85rem;
  font-size: var(--about-type-heading);
  line-height: 1.3;
  color: #111827;
}

.about-hero p {
  margin: 0;
  line-height: 1.75;
  font-size: var(--about-type-body-lg);
  color: #334155;
}

.about-block {
  background: #ffffff;
  border: 1px solid rgba(64, 12, 77, 0.1);
  border-radius: 16px;
  padding: 1.3rem 1.35rem;
}

.about-block h2 {
  margin: 0 0 0.8rem;
  font-size: var(--about-type-subheading);
  color: #400C4D;
}

.about-block p {
  margin: 0 0 0.9rem;
  line-height: 1.8;
  font-size: var(--about-type-body);
  color: #334155;
}

.about-block p:last-child {
  margin-bottom: 0;
}

.about-highlight {
  margin: 0;
  font-weight: 700;
  color: #400C4D;
  font-size: var(--about-type-body);
}

.about-philosophy {
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
}

.about-pillars {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.1rem;
}

.about-pillar {
  background: #f3edf7;
  border-radius: 24px;
  padding: 1.7rem 1.4rem;
  text-align: center;
  border: 1px solid rgba(64, 12, 77, 0.08);
}

.about-pillar-icon {
  width: 72px;
  height: 72px;
  border-radius: 999px;
  margin: 0 auto 1rem;
  background: #e8d8f1;
  color: #400C4D;
  display: grid;
  place-items: center;
  font-size: 2rem;
  font-weight: 700;
}

.about-pillar h3 {
  margin: 0 0 0.7rem;
  font-size: var(--about-type-card-heading);
  color: #400C4D;
  line-height: 1.25;
}

.about-pillar p {
  margin: 0;
  color: #4b5563;
  font-size: var(--about-type-body);
  line-height: 1.55;
}

.about-pillar--featured {
  background: #400C4D;
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 20px 34px rgba(64, 12, 77, 0.32);
}

.about-pillar--featured .about-pillar-icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.about-pillar--featured h3,
.about-pillar--featured p {
  color: #ffffff;
}

.about-philosophy-panel {
  border-radius: 30px;
  padding: 2.3rem 2.5rem;
  background:
    radial-gradient(circle at 0% 100%, rgba(255, 255, 255, 0.08) 0 18%, transparent 19%),
    radial-gradient(circle at 95% 8%, rgba(255, 255, 255, 0.09) 0 16%, transparent 17%),
    linear-gradient(125deg, #400C4D, #400C4D);
  color: #ffffff;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1.5rem;
  align-items: center;
}

.about-philosophy-label {
  margin: 0 0 0.65rem;
  letter-spacing: 0.24em;
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.72);
}

.about-philosophy-copy h3 {
  margin: 0;
  font-size: var(--about-type-heading);
  line-height: 1.15;
  color: #f59e0b;
}

.about-philosophy-sub {
  margin: 0.8rem 0 0.4rem;
  color: rgba(255, 255, 255, 0.75);
  font-style: italic;
  font-size: var(--about-type-subheading);
}

.about-philosophy-divider {
  width: 82px;
  height: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.42);
  margin: 1rem 0 1.1rem;
}

.about-philosophy-text {
  margin: 0;
  color: rgba(255, 255, 255, 0.94);
  font-size: var(--about-type-body-lg);
  line-height: 1.6;
}

.about-philosophy-text strong {
  color: #f59e0b;
}

.about-philosophy-orbit {
  display: grid;
  place-items: center;
  gap: 0.85rem;
}

.about-philosophy-rings {
  width: 180px;
  height: 180px;
  border-radius: 999px;
  position: relative;
  display: grid;
  place-items: center;
}

.about-philosophy-ring {
  border: 5px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  position: absolute;
}

.about-philosophy-ring--outer {
  width: 172px;
  height: 172px;
}

.about-philosophy-ring--inner {
  width: 104px;
  height: 104px;
}

.about-philosophy-core {
  width: 62px;
  height: 62px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
  display: grid;
  place-items: center;
  font-size: 2rem;
}

.about-philosophy-orbit p {
  margin: 0;
  text-align: center;
  color: rgba(255, 255, 255, 0.77);
  line-height: 1.45;
  font-size: var(--about-type-body);
}

.about-quote {
  background: #400C4D;
  border-radius: 16px;
  padding: 1.35rem 1.35rem;
}

.about-quote p {
  margin: 0;
  text-align: center;
  color: #f59e0b;
  font-size: var(--about-type-subheading);
  line-height: 1.9;
  font-weight: 600;
}

.about-closing {
  margin: 0;
  font-weight: 700;
  color: #400C4D;
  font-size: var(--about-type-subheading);
}

@media (max-width: 640px) {
  .about-page {
    padding: 1.6rem 0.9rem 2rem;
  }

  .about-pillars {
    grid-template-columns: 1fr;
  }

  .about-philosophy-panel {
    grid-template-columns: 1fr;
    padding: 1.6rem 1.2rem;
    border-radius: 24px;
  }

  .about-philosophy-copy h3 {
    font-size: 2rem;
  }

  .about-philosophy-text {
    font-size: 1.2rem;
  }

  .about-philosophy-rings {
    width: 144px;
    height: 144px;
  }

  .about-philosophy-ring--outer {
    width: 136px;
    height: 136px;
  }

  .about-philosophy-ring--inner {
    width: 84px;
    height: 84px;
  }

  .about-quote p {
    font-size: 1.05rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/About/about.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,sDAAsD;EACtD,kCAAkC;EAClC,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;;;EAIE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB;;;6CAG2C;EAC3C,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".about-page {\n  --about-type-heading: clamp(2rem, 3vw, 3rem);\n  --about-type-subheading: clamp(1.5rem, 2.2vw, 2.15rem);\n  --about-type-card-heading: 1.35rem;\n  --about-type-body: 1.1rem;\n  --about-type-body-lg: 1.2rem;\n  min-height: 100vh;\n  background: #ece4ed;\n  color: #400C4D;\n  font-family: 'Inter', system-ui, sans-serif;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  padding: 2.5rem 0.6rem 3rem;\n}\n\n.about-hero,\n.about-block,\n.about-quote,\n.about-philosophy {\n  width: min(1220px, 100%);\n  margin: 0 auto;\n}\n\n.about-hero {\n  background: #ffffff;\n  border: 1px solid rgba(64, 12, 77, 0.12);\n  border-radius: 16px;\n  padding: 1.5rem 1.35rem;\n}\n\n.about-eyebrow {\n  margin: 0 0 0.6rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: #400C4D;\n}\n\n.about-hero h1 {\n  margin: 0 0 0.85rem;\n  font-size: var(--about-type-heading);\n  line-height: 1.3;\n  color: #111827;\n}\n\n.about-hero p {\n  margin: 0;\n  line-height: 1.75;\n  font-size: var(--about-type-body-lg);\n  color: #334155;\n}\n\n.about-block {\n  background: #ffffff;\n  border: 1px solid rgba(64, 12, 77, 0.1);\n  border-radius: 16px;\n  padding: 1.3rem 1.35rem;\n}\n\n.about-block h2 {\n  margin: 0 0 0.8rem;\n  font-size: var(--about-type-subheading);\n  color: #400C4D;\n}\n\n.about-block p {\n  margin: 0 0 0.9rem;\n  line-height: 1.8;\n  font-size: var(--about-type-body);\n  color: #334155;\n}\n\n.about-block p:last-child {\n  margin-bottom: 0;\n}\n\n.about-highlight {\n  margin: 0;\n  font-weight: 700;\n  color: #400C4D;\n  font-size: var(--about-type-body);\n}\n\n.about-philosophy {\n  display: flex;\n  flex-direction: column;\n  gap: 1.3rem;\n}\n\n.about-pillars {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1.1rem;\n}\n\n.about-pillar {\n  background: #f3edf7;\n  border-radius: 24px;\n  padding: 1.7rem 1.4rem;\n  text-align: center;\n  border: 1px solid rgba(64, 12, 77, 0.08);\n}\n\n.about-pillar-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 999px;\n  margin: 0 auto 1rem;\n  background: #e8d8f1;\n  color: #400C4D;\n  display: grid;\n  place-items: center;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.about-pillar h3 {\n  margin: 0 0 0.7rem;\n  font-size: var(--about-type-card-heading);\n  color: #400C4D;\n  line-height: 1.25;\n}\n\n.about-pillar p {\n  margin: 0;\n  color: #4b5563;\n  font-size: var(--about-type-body);\n  line-height: 1.55;\n}\n\n.about-pillar--featured {\n  background: #400C4D;\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 20px 34px rgba(64, 12, 77, 0.32);\n}\n\n.about-pillar--featured .about-pillar-icon {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n\n.about-pillar--featured h3,\n.about-pillar--featured p {\n  color: #ffffff;\n}\n\n.about-philosophy-panel {\n  border-radius: 30px;\n  padding: 2.3rem 2.5rem;\n  background:\n    radial-gradient(circle at 0% 100%, rgba(255, 255, 255, 0.08) 0 18%, transparent 19%),\n    radial-gradient(circle at 95% 8%, rgba(255, 255, 255, 0.09) 0 16%, transparent 17%),\n    linear-gradient(125deg, #400C4D, #400C4D);\n  color: #ffffff;\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.about-philosophy-label {\n  margin: 0 0 0.65rem;\n  letter-spacing: 0.24em;\n  font-size: 1.05rem;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.about-philosophy-copy h3 {\n  margin: 0;\n  font-size: var(--about-type-heading);\n  line-height: 1.15;\n  color: #f59e0b;\n}\n\n.about-philosophy-sub {\n  margin: 0.8rem 0 0.4rem;\n  color: rgba(255, 255, 255, 0.75);\n  font-style: italic;\n  font-size: var(--about-type-subheading);\n}\n\n.about-philosophy-divider {\n  width: 82px;\n  height: 5px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.42);\n  margin: 1rem 0 1.1rem;\n}\n\n.about-philosophy-text {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.94);\n  font-size: var(--about-type-body-lg);\n  line-height: 1.6;\n}\n\n.about-philosophy-text strong {\n  color: #f59e0b;\n}\n\n.about-philosophy-orbit {\n  display: grid;\n  place-items: center;\n  gap: 0.85rem;\n}\n\n.about-philosophy-rings {\n  width: 180px;\n  height: 180px;\n  border-radius: 999px;\n  position: relative;\n  display: grid;\n  place-items: center;\n}\n\n.about-philosophy-ring {\n  border: 5px solid rgba(255, 255, 255, 0.2);\n  border-radius: 999px;\n  position: absolute;\n}\n\n.about-philosophy-ring--outer {\n  width: 172px;\n  height: 172px;\n}\n\n.about-philosophy-ring--inner {\n  width: 104px;\n  height: 104px;\n}\n\n.about-philosophy-core {\n  width: 62px;\n  height: 62px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.22);\n  display: grid;\n  place-items: center;\n  font-size: 2rem;\n}\n\n.about-philosophy-orbit p {\n  margin: 0;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.77);\n  line-height: 1.45;\n  font-size: var(--about-type-body);\n}\n\n.about-quote {\n  background: #400C4D;\n  border-radius: 16px;\n  padding: 1.35rem 1.35rem;\n}\n\n.about-quote p {\n  margin: 0;\n  text-align: center;\n  color: #f59e0b;\n  font-size: var(--about-type-subheading);\n  line-height: 1.9;\n  font-weight: 600;\n}\n\n.about-closing {\n  margin: 0;\n  font-weight: 700;\n  color: #400C4D;\n  font-size: var(--about-type-subheading);\n}\n\n@media (max-width: 640px) {\n  .about-page {\n    padding: 1.6rem 0.9rem 2rem;\n  }\n\n  .about-pillars {\n    grid-template-columns: 1fr;\n  }\n\n  .about-philosophy-panel {\n    grid-template-columns: 1fr;\n    padding: 1.6rem 1.2rem;\n    border-radius: 24px;\n  }\n\n  .about-philosophy-copy h3 {\n    font-size: 2rem;\n  }\n\n  .about-philosophy-text {\n    font-size: 1.2rem;\n  }\n\n  .about-philosophy-rings {\n    width: 144px;\n    height: 144px;\n  }\n\n  .about-philosophy-ring--outer {\n    width: 136px;\n    height: 136px;\n  }\n\n  .about-philosophy-ring--inner {\n    width: 84px;\n    height: 84px;\n  }\n\n  .about-quote p {\n    font-size: 1.05rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
